import React, { useContext } from 'react';
import { TopBarWrapper, Title, Bar, VersionNumber, Search } from './TopBar_SC';
import { SearchBox, SearchBox_onSuggestionClickEvent, XISVG } from '@inmoment/the-kitchen';
import { KitchenContext } from '../../../App';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FAQ, graphics, template } from '../../../utils/copy';
import { useCurrentUserInfo } from '../../../pages/hiddenPages/userInfo/UpdateUserInfo';

export const TopBar = (): JSX.Element => {
  const { versionNumber, allCombinedTags } = useContext(KitchenContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isUserInfoPage = pathname === '/UserInfo';
  const { email, team } = useCurrentUserInfo();

  const hyphenate = (text: string) => text.split(' ').join('-');
  const split = (text: string): string[] => text.split(' – ');
  const push = (page: string) => navigate('/' + page);
  const scroll = (text: string) => setTimeout(() => document.getElementById(text)?.scrollIntoView({ behavior: 'smooth' }), 100);

  // search click functionality
  const handleSuggestionClick = ({ suggestion: { text, id } }: SearchBox_onSuggestionClickEvent) => {
    const [comp, category] = split(text);

    if (id && Number.isInteger(+id)) {
      push(`Pattern/${id}`);
    } else {
      switch (id) {
        case 'Component':
        case graphics:
          push(hyphenate(category));
          scroll(hyphenate(comp));
          break;

        case 'Icon':
        case 'AppIcon':
          push('Icons');
          break;

        case FAQ:
          push(id);
          break;

        case template:
          push(hyphenate(comp));
          break;

        default:
          push(hyphenate(comp === 'AppIcons' ? 'Icons' : comp));
      }
    }
  };

  return (
    <TopBarWrapper>
      <Title>
        <div style={{ margin: 72 }}>
          <XISVG svg="inmoment_main_full_color" style={{ marginRight: 12 }} />
        </div>
      </Title>
      <Bar />

      <p style={{ marginLeft: 18, marginRight: 18 }}>Design System</p>
      <Bar />

      <Search>
        <SearchBox
          hasOutline={false}
          placeholder={isUserInfoPage ? 'Must update information before searching' : 'Search'}
          data={allCombinedTags}
          onSuggestionClick={handleSuggestionClick}
          maxSuggestions={50}
          disabled={isUserInfoPage}
        />
      </Search>
      <Bar />

      {email && team && (
        <>
          <Link to="/UserInfo" style={{ marginLeft: 12, marginRight: 12 }}>
            {email.toLowerCase().replace('@inmoment.com', '')} ({team} Team)
          </Link>
          <Bar />
        </>
      )}

      <VersionNumber width="auto">
        <Link className="kxi-text-small kxi-text-600 kxi-text-center" to={isUserInfoPage ? '#' : '/Updates'}>
          Running v{versionNumber ?? 'Version'}
        </Link>
      </VersionNumber>
      <Bar />
    </TopBarWrapper>
  );
};
